'use client';

import {Languages} from '@shared/languages';
import ProxyImage from '@shared/ProxyImage/ProxyImage';
import cn from '@sindresorhus/class-names';
import classNames from '@sindresorhus/class-names';
import {type AppFromBackapi} from '@utils/fetchAppsByPackageNames';
import {retryPromise} from '@utils/retryPromise';
import {lazy, Suspense} from 'react';

import {PicksSearch} from '@web-landing/components/PicksSearch/PicksSearch';
import {PlaceholderPicks} from '@web-landing/components/SearchPicks';

import {SearchBlockType} from '@strapi/types/MainLanding';

import {getLocalisedEmptySearchResult} from '@web-landing/utils/getLocaleFallback';

import stylesOld from './SearchPicksBlock.module.scss';
import stylesNew from './SearchPicksBlock_redesign.module.scss';

type Props = {
  selections?: Array<AppFromBackapi>;
  apiUrl?: string;
  searchBlock: SearchBlockType;
  locale?: Languages;
  redesignMode?: 'default' | 'colored' | '';
  webGatewayRequestUrl?: string;
};
const MiniPicks = lazy(
  retryPromise(
    async () =>
      import(
        /* webpackChunkName: "MiniPicks" */ '@web-landing/components/SearchPicks/MiniPicks/MiniPicks'
      ),
    {fallback: {default: PlaceholderPicks}},
  ),
);

export const SearchPicksBlock = ({
  selections,
  apiUrl,
  searchBlock,
  locale,
  redesignMode,
  webGatewayRequestUrl,
}: Props) => {
  const styles = redesignMode ? stylesNew : stylesOld;

  return (
    <div
      className={classNames(
        redesignMode === 'default' &&
          searchBlock.backgroundImage?.url &&
          styles.imageWrapper,
      )}
    >
      {redesignMode === 'default' && searchBlock.backgroundImage?.url && (
        <ProxyImage
          className={styles.backgroundImage}
          imageData={searchBlock.backgroundImage}
        />
      )}
      <div
        className={classNames(styles.searchWrapper, {
          [styles.searchWrapper__nomargin]: redesignMode === 'default',
        })}
      >
        <div className={styles.search}>
          <h2
            className={cn(styles.title, {
              [styles.chineseTitle]: locale === 'zh',
            })}
          >
            {searchBlock?.title ?? 'Найди любимое приложение'}
          </h2>
          <PicksSearch
            requestUrl={apiUrl}
            searchBlock={{
              ...searchBlock,
              emptyResultText: getLocalisedEmptySearchResult(locale),
            }}
            webGatewayRequestUrl={webGatewayRequestUrl}
            redesignMode={redesignMode}
          />
        </div>
        {!!selections?.length && (
          <Suspense fallback={<PlaceholderPicks apps={selections} />}>
            <MiniPicks
              apps={selections}
              metricsName="MiniPicks"
              redesign={!!redesignMode}
            />
          </Suspense>
        )}
      </div>
    </div>
  );
};
